import { isClubHost } from "./bizHost";

/**
 * Domain-based landing page detection
 * Determines which landing page version to display based on hostname
 */

const SHORT_LANDING_DOMAINS = [
  "ads.winaz.it.com",
  "fb.winaz.it.com",
  "qc.winaz.it.com",
  "ads.winaz.ru.com",
  "fb.winaz.ru.com",
  "qc.winaz.ru.com",
];

const SHORT_LANDING_2_DOMAINS = [
  "dkwinaz.vip",
];

const TAN_THU_DOMAINS = [
  "winaz.work",
  "winaz.space",
  "vipwinaz.com",
  "quawinaz.com",
];

const WINAZ_29K_DOMAINS = [
  "winaz.it.com",
];

const NO2_DOMAINS = [
  "winaz.space"
];

const LIVE_LANDING_DOMAINS = [
  "xocdiawinaz.com",
  "xdwinaz.com"
];

const TLMN2_DOMAINS = [
  "tlmnwinaz.vip",
  "tienlenwinaz.vip",
];

const SIMPLE_LANDING_DOMAINS = [
  "winaz.ru.com",
  "dkwinaz.com",
  "winaz.io",
  "gamewinaz.com",
  "playwinaz.com",
  "dkwinaz.it.com",
  "dangkywinaz.com",
];

/**
 * Check if current domain should display short landing page
 * @returns true if domain is in SHORT_LANDING_DOMAINS, false otherwise
 */
export function isShortLanding(): boolean {
  if (typeof window === "undefined") {
    return false; // Server-side rendering fallback
  }

  return SHORT_LANDING_DOMAINS.includes(window.location.hostname);
}

/**
 * Check if current domain should display short landing 2 page
 * @returns true if domain is in SHORT_LANDING_2_DOMAINS, false otherwise
 */
export function isShortLanding2(): boolean {
  if (typeof window === "undefined") {
    return false; // Server-side rendering fallback
  }

  return SHORT_LANDING_2_DOMAINS.includes(window.location.hostname);
}

/**
 * Check if current domain should display Home-Winaz-29K landing page
 * @returns true if domain is in WINAZ_29K_DOMAINS, false otherwise
 */
export function is29KLanding(): boolean {
  if (typeof window === "undefined") {
    return false; // Server-side rendering fallback
  }

  return WINAZ_29K_DOMAINS.includes(window.location.hostname);
}

/**
 * Check if current domain should display live landing page (Home-Winaz-Live)
 * @returns true if domain is in LIVE_LANDING_DOMAINS, false otherwise
 */
export function isLiveLanding(): boolean {
  if (typeof window === "undefined") {
    return false; // Server-side rendering fallback
  }

  return LIVE_LANDING_DOMAINS.includes(window.location.hostname);
}

/**
 * Check if current domain should display simple landing page
 * @returns true if domain is in SIMPLE_LANDING_DOMAINS, false otherwise
 */
export function isSimpleLanding(): boolean {
  if (typeof window === "undefined") {
    return false; // Server-side rendering fallback
  }

  return SIMPLE_LANDING_DOMAINS.includes(window.location.hostname);
}

/**
 * Check if current domain should display Tan Thu landing page (Home-Winaz-Tan-Thu)
 * @returns true if domain is in TAN_THU_DOMAINS, false otherwise
 */
export function isTanThuLanding(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  return TAN_THU_DOMAINS.includes(window.location.hostname);
}

/**
 * Check if current domain should display No2 landing page (Home-Winaz-No2)
 * @returns true if domain is in NO2_DOMAINS, false otherwise
 */
export function isNo2Landing(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  return NO2_DOMAINS.includes(window.location.hostname);
}

/**
 * Check if current domain should display TLMN 2 landing page (Home-Winaz-TLMN-2)
 * @returns true if domain is in TLMN2_DOMAINS, false otherwise
 */
export function isTLMN2Landing(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  return TLMN2_DOMAINS.includes(window.location.hostname);
}

/**
 * Get current hostname
 * @returns current window.location.hostname
 */
export function getCurrentHostname(): string {
  if (typeof window === "undefined") {
    return "";
  }
  return window.location.hostname;
}

export function isClubLanding(): boolean {
  if (typeof window === "undefined") return false;
  return isClubHost(window.location.hostname, window.location.search);
}
